<nz-spin [nzSpinning]="isSpinning" [nzTip]="spinningMsg">


    <div class="board-container">
        <h2 class="board-title">Onboarding Board</h2>
        <div class="board-columns" *ngIf="bucketColumns?.length > 0">
            <div class="board-columns-buckets" cdkDropList cdkDropListOrientation="horizontal" [cdkDropListData]="bucketColumns" (cdkDropListDropped)="dropColumn($event)">
                <div *ngFor="let column of bucketColumns" class="board-column" cdkDrag [cdkDragDisabled]="column.id === 'unassigned'">
                    <h3 class="column-title column-title-draggable" cdkDragHandle>{{ column.name }}</h3>
                    <div class="column-cards" cdkDropList #cardList="cdkDropList" [id]="column.id" [cdkDropListData]="column.cards" [cdkDropListConnectedTo]="connectedLists" (cdkDropListDropped)="drop($event, column.cards)">
                        <div *ngFor="let card of column.cards" class="board-card" cdkDrag (click)="openCard(card)">
                            <div class="card-content" cdkDragHandle>
                                <span class="card-title">{{ card.firstName | titlecase }} {{ card.lastName | titlecase }}</span>
                                <nz-tag style="align-self: end;" *ngIf="card?.totalactions != 0" [nzColor]="card?.doneCount == card?.totalactions ? 'success' : 'warning'">
                                    <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                                    {{ card?.doneCount }} / {{ card?.totalactions }}
                                </nz-tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="board-columns" *ngIf="bucketColumns?.length === 0">
            <div class="board-column">
                <h3 class="column-title">No columns found</h3>
            </div>
        </div>
    </div>
</nz-spin>


<nz-modal [(nzVisible)]="actionsModal" [nzTitle]="modalTitle" [nzFooter]="null" (nzOnCancel)="cancelActionsModal()" [nzWidth]="'90%'">

    <ng-template #modalTitle>
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding-right: 24px;">
        <span>{{ selectedCard?.firstName }} {{ selectedCard?.lastName }}</span>
        
        <button nz-button nzType="link" (click)="viewCardHistory()">
          <span nz-icon nzType="history"></span>
          View Card History
        </button>
      </div>
    </ng-template>

    <ng-container *nzModalContent>
      <div *ngFor="let b of actionsByBuckets">
        <div>
            <h3>{{ b.bucket }}</h3>
            <nz-progress [nzPercent]="actionProgress(b)"></nz-progress>
        </div>
        <ul nz-list nzBordered> 
            <li *ngFor="let action of b.actions" nz-list-item>
                
                <nz-list-item-meta [nzTitle]="actionName" [nzAvatar]="statusToggle">
                    
                    <ng-template #actionName>
                        {{ action.name | titlecase }}
                    </ng-template>

                    <ng-template #statusToggle>
                        <button nz-button nzType="default" nzShape="circle" (click)="toggleStatus(action)" *ngIf="action.status != 'done'"> 
                            <span nz-icon nzType="line" nzTheme="outline"></span>
                        </button>
                        <button nz-button nzType="primary" nzShape="circle" (click)="toggleStatus(action)" *ngIf="action.status == 'done'"> <nz-icon nzType="search" /> 
                            <span nz-icon nzType="check" nzTheme="outline"></span>
                        </button>
                    </ng-template>
                </nz-list-item-meta>
                
                <ul nz-list-item-actions>
                    <nz-list-item-action>
                        <button nz-button nzType="link" (click)="viewActionHistory(action)">
                            <span nz-icon nzType="history"></span>
                            View Action History
                        </button>
                    </nz-list-item-action>
                </ul>

            </li>
        </ul>


      </div>
    </ng-container>
</nz-modal>

<nz-drawer (nzOnClose)="closeDrawer()" [nzVisible]="actionHistoryDrawer" nzPlacement="right" [nzTitle]="actionDrawerData?.name" [nzZIndex]="1100">
    <ng-container *nzDrawerContent>
    <form [formGroup]="noteForm">
        <nz-form-item>
            <nz-form-control>
                <nz-textarea-count [nzMaxCharacterCount]="150">
                    <textarea rows="4" maxlength="150" nz-input placeholder="Add a note" formControlName="note"></textarea>
                </nz-textarea-count>
            </nz-form-control>
        </nz-form-item>
    </form>
    <div class="btn-note-cont">
        <button nz-button nzType="default">Reset Note</button>
        <button nz-button nzType="primary" (click)="addNote()" [disabled]="noteForm.invalid">Save Note</button>
    </div>
    <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngFor="let hist of sort()">
        <nz-list-item-meta [nzDescription]="hist?.by ? hist?.by : 'System'">
            <nz-list-item-meta-title>
            <p style="color: grey;" *ngIf="hist?.log"> ~ {{hist?.date | date}}: {{ hist.log }} </p>
            <p *ngIf="hist?.note"> {{hist?.date | date}}:  {{ hist.note }} </p>
            </nz-list-item-meta-title>
        </nz-list-item-meta>
        </nz-list-item>
    </nz-list>
    </ng-container>
</nz-drawer>

<nz-drawer (nzOnClose)="closeCardDrawer()" [nzVisible]="cardHistoryDrawer" nzPlacement="right" [nzTitle]="selectedCard?.firstName + ' ' + selectedCard?.lastName + ' history'" [nzZIndex]="1100">
    <ng-container *nzDrawerContent>
    <h4>This is a notes/history for the card</h4>
    <form [formGroup]="noteForm">
        <nz-form-item>
            <nz-form-control>
                <nz-textarea-count [nzMaxCharacterCount]="150">
                    <textarea rows="4" maxlength="150" nz-input placeholder="Add a note" formControlName="note"></textarea>
                </nz-textarea-count>
            </nz-form-control>
        </nz-form-item>
    </form>
    <div class="btn-note-cont">
        <button nz-button nzType="default" (click)="noteForm.reset()">Reset Note</button>
        <button nz-button nzType="primary" (click)="addCardNote()" [disabled]="noteForm.invalid">Save Note</button>
    </div>
    <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngFor="let hist of sortCardHist()">
        <nz-list-item-meta [nzDescription]="hist?.by ? hist?.by : 'System'">
            <nz-list-item-meta-title>
            <p style="color: grey;" *ngIf="!hist?.note"> ~ {{hist?.date | date}}: Moved from {{ hist.fromOnboardingId }} to {{ hist.toOnboardingId }} </p>
            <p *ngIf="hist?.note"> {{hist?.date | date}}:  {{ hist.note }} </p>
            </nz-list-item-meta-title>
        </nz-list-item-meta>
        </nz-list-item>
    </nz-list>
    </ng-container>
</nz-drawer>

